var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// TODO: remove duplicate cookie library from bundle
import cookies from 'js-cookie';
import topDomain from '@segment/top-domain';
import { EventEmitter } from 'events';
export var DEFAULT_COOKIE_NAME = 'ht-cm-preferences';
var COOKIE_DEFAULT_EXPIRES = 365;
// TODO: harden against invalid cookies
// TODO: harden against different versions of cookies
export function loadPreferences(cookieName) {
    var preferences = cookies.getJSON(cookieName || DEFAULT_COOKIE_NAME);
    if (!preferences) {
        return {};
    }
    return {
        destinationPreferences: preferences.destination,
        customPreferences: preferences.custom
    };
}
var emitter = new EventEmitter();
/**
 * Subscribes to consent preferences changing over time and returns
 * a cleanup function that can be invoked to remove the instantiated listener.
 *
 * @param listener a function to be invoked when ConsentPreferences are saved
 */
export function onPreferencesSaved(listener) {
    emitter.on('preferencesSaved', listener);
    return function () { return emitter.off('preferencesSaved', listener); };
}
export function savePreferences(_a) {
    var destinationPreferences = _a.destinationPreferences, customPreferences = _a.customPreferences, cookieDomain = _a.cookieDomain, cookieName = _a.cookieName, cookieExpires = _a.cookieExpires, _b = _a.cookieAttributes, cookieAttributes = _b === void 0 ? {} : _b;
    var wd = window;
    if (wd.htevents) {
        wd.htevents.identify({
            destinationTrackingPreferences: destinationPreferences,
            // use `categoryTrackingPreferences` here for consistency with `context.consent.categoryPreferences`
            categoryTrackingPreferences: customPreferences
        });
        wd.htevents.track('Consent Updated', {
            destinationTrackingPreferences: destinationPreferences,
            // use `categoryTrackingPreferences` here for consistency with `context.consent.categoryPreferences`
            categoryTrackingPreferences: customPreferences
        });
    }
    else {
        console.warn('window.htevents not found...is the SDK snippet included on the page?');
    }
    var domain = cookieDomain || topDomain(window.location.href);
    var expires = cookieExpires || COOKIE_DEFAULT_EXPIRES;
    var value = {
        version: 1,
        destination: destinationPreferences,
        custom: customPreferences
    };
    cookies.set(cookieName || DEFAULT_COOKIE_NAME, value, __assign({ expires: expires,
        domain: domain }, cookieAttributes));
    emitter.emit('preferencesSaved', {
        destinationPreferences: destinationPreferences,
        customPreferences: customPreferences
    });
}
//# sourceMappingURL=data:application/json;base64,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